import { BasePagePath } from 'app/core/workflow/page-path/base-page.path';

export class TermsAndConditionsPagePath extends BasePagePath {
  public static path(): string {
    return 'terms-and-conditions';
  }
}
